<template>
  <v-container fluid class="batchpayment-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Payment</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>
          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Payment</p>
                        <v-select
                          class="mb-4"
                          :items=paymenttype
                          v-model="new_batchpayment.paymenttype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the payment type">
                        </v-select>
                        <v-menu
                          ref="menu_paymentdate"
                          v-model="menu_paymentdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_batchpayment.paymentdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_batchpayment.paymentdate"
                              label="Payment Date"
                              v-bind="attrs"
                              v-bind:value="new_batchpayment.paymentdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the payment date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_batchpayment.paymentdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paymentdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_paymentdate.save(new_batchpayment.paymentdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="data_accounts"
                          v-model="new_batchpayment.accountid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="new_batchpayment.locationid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_batchpayment.refnum"
                          outlined
                          dense
                          placeholder="Reference"
                          persistent-hint
                          single-line hint="Enter the reference or description">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_batchpayment.paymentnote"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line hint="Enter the note">
                        </v-text-field>
                      </v-form>
                    </v-col>   
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-switch
                            class="mb-6"
                            color="primary"
                            v-on:change="onChangeOptions($event)"
                            v-model="new_batchpayment.isSecondaryCurrency"
                            hint="Secondary Currency"
                            :true-value="true"
                            :false-value="false"
                            persistent-hint
                        ></v-switch>
                        <v-text-field
                          v-if="isCurrencyRate"
                          type="number"
                          class="mb-4"
                          outlined
                          dense
                          v-model="new_batchpayment.currencyRate"
                          placeholder="Currency Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                              @click="cancelBatchPayment"
                              replace
                              outlined
                              color="primary"
                          >
                            Cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <v-data-table
                        hide-default-footer
                        :headers="header_transactions"
                        :items="data_transactions"
                        :items-per-page="500"
                        class="elevation-0"
                      >
                        <template v-slot:item.transimage="{ item }">
                          <v-img
                            v-if="item.transimage" 
                            v-bind:src="item.transimage"
                            max-height="70"
                            max-width="70"
                            ></v-img>
                          </template>
                          <template v-slot:item.transnum="{ item }">
                            <p class="two-line">{{ item.transtype  }}</p>
                            <p class="two-line">{{ item.transnum  }}</p>
                            <p v-if="item.transdate!=undefined" class="two-line">{{ new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
                          </template>
                          <template v-slot:item.transname="{ item }">
                            <p class="two-line">{{ item.transname }}</p>
                            <p class="two-line">{{ item.transaddress }}</p>
                            <p v-if="item.locationid!=undefined" class="two-line">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }}</p>
                          </template>
                          <template v-slot:item.transaddress="{ item }">
                            {{ item.transaddress.toLocaleString('en-SG') }}
                          </template>
                          <template v-slot:item.transamount="{ item }">
                            <div style="margin-top: 35px; margin-bottom: 0; align-content: center;">
                              <v-text-field
                                outlined
                                dense
                                persistent-hint
                                class="mb-4"
                                placeholder="Qty"  
                                type="number"
                                v-model="item.transamount"
                                oninput="if(this.value < 1) this.value = 1;"
                              >
                              </v-text-field>            
                            </div>
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="deleteBill(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <template slot="body.append">
                            <tr>
                              <th></th>
                              <th></th>
                              <th>Total</th>
                              <th>{{ sum_amount }}</th>
                              <th>{{ sum_deposit_amount }}</th>
                              <th></th>
                            </tr>
                          </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertBatchPayment()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import { sortDataAsc } from '@/util/tools';

export default {
  data () {
    return {
      step: 1,
      errorindex: undefined,
      haserror: false,
      error: undefined,
      menu_paymentdate: false,
      isFrom: null,
      isCurrencyRate: false,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      header_transactions: [
        { text: 'Image', value: 'transimage', width: '100px'},
        { text: 'Bill', value: 'transnum' },
        { text: 'Pay To', value: 'transname' },
        { text: 'Bill Amount', value: 'transtotal', width: '12%' },
        { text: 'Pay Amount', value: 'transamount', width: '12%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      data_bills: [],
      data_transactions: [],
      paymenttype: ['Batch Payment'],
      new_batchpayment: {},
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Bill', ['bills']),
    ...mapState('BatchPayment', ['batchpayments', 'isReceiving']),
    ...mapState('Location', ['locations']),
    ...mapState('SystemSetting', ['settings']),
    sum_amount(){
      let result = this.data_transactions.reduce((a, b) => a + parseFloat(b.transtotal), 0);
      return isNaN(result) ? 0 : result;
    },
    sum_deposit_amount(){
      let result = this.data_transactions.reduce((a, b) => a + parseFloat(b.transamount), 0);
      return isNaN(result) ? 0 : result;
    },
    data_accounts(){
      let results = this.accounts.filter(i=>i.accountsubclass=='Bank' || i.accountsubclass=='Cash');
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Bill', ['getBillsRequest']),
    ...mapActions('BatchPayment', ['insertBatchPaymentRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    calculateTotal(){
      let update = {
        billtotal: this.data_bills.reduce((partial_sum, item) => parseFloat(partial_sum) + parseFloat(item.billtotal),0),
        paymenttotal: this.data_bills.reduce((partial_sum, item) => parseFloat(partial_sum) + parseFloat(item.paymentamount),0),
      };
      this.new_batchpayment = Object.assign({}, this.new_batchpayment, update);
    },
    checkError(){
      if(this.data_bills.length==0){
        this.haserrors = true;
        return false;
      }
      this.step = 2;
      this.errorindex = -1;
      return true;
    },
    checkError2(){
      this.step = 2;
      if(!this.new_batchpayment.paymenttype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_batchpayment.paymentdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_batchpayment.accountid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_batchpayment.locationid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    deleteBill(item){
      let index = this.findOrderIndexById(item._id);
      this.data_bills.splice(index,1);
      this.calculateTotal();
    },
    findOrderIndexById(id){
      let index;
      if(this.data_bills.find(item=>item._id==id)==null) {return -1}
      for(index=0; index<this.data_bills.length; index++){
        if(this.data_bills[index]._id==id){break;}
      }
      return index;
    },
    cancelBatchPayment(){
      if(this.$route.params._isFrom!=null) router.push({ name: this.$route.params._isFrom });
      else router.push('/batchpayment/list');
    },
    async insertBatchPayment() {
      if(!this.checkError2()) return;
      let json = {payment: this.new_batchpayment, transactions: this.data_transactions };
      console.log(json)
      await this.insertBatchPaymentRequest(json);
      router.push('/batchpayment/list');
    },
    onChangeOptions(value){
      console.log(value)
      this.isCurrencyRate = value;
      if(value==true) this.new_batchpayment.currencyRate = this.data_bills[0].currencyRate;
      else this.new_batchpayment.currencyRate = null;
      //this.change_options[field] = value;
    },
    arrangeBills(){
      sortDataAsc(this.data_bills, 'billnum')
      this.new_batchpayment.isFrom = 'bill';
      this.new_batchpayment.refnum = this.data_bills.length>0 ? this.data_bills[0].refnum : '';
      for(var i in this.data_bills){
        let bill = this.data_bills[i];
        let trans = {};
        trans['id'] = bill._id;
        trans['billid'] = bill._id;
        trans['locationid'] = bill.locationid;
        trans['channelid'] = bill.channelid;
        trans['vendorid'] = bill.vendorid;
        trans['transtype'] = bill.billtype;
        trans['transnum'] = bill.billnum;
        trans['refnum'] = bill.refnum;
        trans['transdate'] = bill.billdate;
        trans['transname'] = bill.billname;
        trans['transaddress'] = bill.billaddress;
        trans['transimage'] = bill.billimage;
        trans['transtotal'] = bill.billtotal;
        trans['transamount'] = parseFloat(bill.billtotal.toFixed(2));
        this.data_transactions.push(trans);
      }
    },
    arrangePurchases(){
      sortDataAsc(this.data_bills, 'purchaseordernum')
      this.new_batchpayment.isFrom = 'purchaseorder';
      for(var i in this.data_bills){
        let bill = this.data_bills[i];
        let trans = {};
        trans['id'] = bill._id;
        trans['purchaseorderid'] = bill._id;
        trans['locationid'] = bill.locationid;
        trans['channelid'] = bill.channelid;
        trans['vendorid'] = bill.vendorid;
        trans['transtype'] = bill.purchaseordertype;
        trans['transnum'] = bill.purchaseordernum;
        trans['refnum'] = bill.refnum;
        trans['transdate'] = bill.purchaseorderdate;
        trans['transname'] = bill.purchaseordername;
        trans['transaddress'] = bill.purchaseorderaddress;
        trans['transimage'] = bill.purchaseorderimage;
        trans['transtotal'] = bill.purchaseordertotal;
        trans['transamount'] = parseFloat(bill.purchaseordertotal.toFixed(2));
        this.data_transactions.push(trans);
      }
    },
    arrangeFABills(){
      sortDataAsc(this.data_bills, 'assetnum')
      this.new_batchpayment.isFrom = 'fabill';
      for(var i in this.data_bills){
        let bill = this.data_bills[i];
        let trans = {};

        trans['id'] = bill._id;
        trans['fabillid'] = bill._id;
        trans['locationid'] = bill.locationid;
        trans['channelid'] = bill.channelid;
        trans['vendorid'] = bill.vendorid;
        trans['transtype'] = bill.assettype;
        trans['transnum'] = bill.assetnum;
        trans['refnum'] = bill.refnum;
        trans['transdate'] = bill.assetdate;
        trans['transname'] = bill.assetname;
        trans['transaddress'] = bill.assetaddress;
        trans['transimage'] = bill.assetimage;
        trans['transtotal'] = bill.assettotal;
        trans['transamount'] = parseFloat(bill.assettotal.toFixed(2));
        this.data_transactions.push(trans);
      }
    },
    arrangeReimbursements(){
      sortDataAsc(this.data_bills, 'reimbursementnum')
      this.new_batchpayment.isFrom = 'reimbursement';
      for(var i in this.data_bills){
        let bill = this.data_bills[i];
        let trans = {};
        trans['id'] = bill._id;
        trans['reimbursementid'] = bill._id;
        trans['locationid'] = bill.locationid;
        trans['channelid'] = bill.channelid;
        trans['vendorid'] = bill.vendorid;
        trans['transtype'] = bill.reimbursementtype;
        trans['transnum'] = bill.reimbursementnum;
        trans['refnum'] = `${bill.reimbursementtype} ${bill.reimbursementnum}`;
        trans['transdate'] = bill.reimbursementdate;
        trans['transname'] = `${bill.reimbursementtype} ${bill.reimbursementnum}`;
        trans['transaddress'] = bill.reimbursementaddress;
        trans['transimage'] = bill.reimbursementimage;
        trans['transtotal'] = bill.reimbursementtotal;
        trans['transamount'] = parseFloat(bill.reimbursementtotal.toFixed(2));
        this.data_transactions.push(trans);
      }
    },
    arrangePayrolls(){
      sortDataAsc(this.data_bills, 'payrollnum')
      this.new_batchpayment.isFrom = 'payroll';
      this.new_batchpayment.refnum = this.data_bills[0].payrollname;
      for(var i in this.data_bills){
        let bill = this.data_bills[i];
        let trans = {};
        trans['id'] = bill._id;
        trans['payrollid'] = bill._id;
        trans['transtype'] = bill.payrolltype;
        trans['transnum'] = bill.payrollnum;
        trans['refnum'] = `${bill.payrolltype} ${bill.payrollnum}`;
        trans['transdate'] = bill.payrolldate;
        trans['transname'] = bill.payrollname;
        trans['transtotal'] = bill.payrolltotal;
        trans['transamount'] = parseFloat(bill.payrolltotal.toFixed(2));
        this.data_transactions.push(trans);
      }
    },
    arrangePayStatements(){
      sortDataAsc(this.data_bills, 'paystatementnum')
      this.new_batchpayment.isFrom = 'paystatement';
      this.new_batchpayment.refnum = `${this.data_bills[0].paystatementtype} ${this.data_bills[0].paystatementnum}`;
      for(var i in this.data_bills){
        let bill = this.data_bills[i];
        let trans = {};
        trans['id'] = bill._id;
        trans['paystatementid'] = bill._id;
        trans['transtype'] = bill.paystatementtype;
        trans['transnum'] = bill.paystatementnum;
        trans['refnum'] = `${bill.paystatementtype} ${bill.paystatementnum}`;
        trans['transdate'] = bill.paystatementdate;
        trans['transname'] = bill.paystatementname;
        trans['transtotal'] = bill.paystatementnetpay;
        trans['transamount'] = parseFloat(bill.paystatementnetpay.toFixed(2));
        this.data_transactions.push(trans);
      }
    },
  },
  async created () {    
    this.data_bills = Object.assign([],this.$route.params.bills);
    if(!this.data_bills) this.$router.push({name: 'BatchPaymentList'});
    if(this.$route.params.isBills==true) this.arrangeBills();
    else if(this.$route.params.isFABills==true) this.arrangeFABills();
    else if(this.$route.params.isPurchases==true) this.arrangePurchases();
    else if(this.$route.params.isRemibursements) this.arrangeReimbursements();
    else if(this.$route.params.isPayrolls==true) this.arrangePayrolls();
    else if(this.$route.params.isPayStatements==true) this.arrangePayStatements();

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();

  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
